module.exports = __webpack_public_path__ + "static/media/german-word-for-black.ebbc3b08.jpg";